import { Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { FichajeCard } from './FichajeCard';
import { getFichajesUsuario } from '../../services/apis';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { mesName } from '../../utils/utils';
import { SelectorMes } from '../../utils/componentes-utiles/SelectorMes';
import { SelectorYear } from '../../utils/componentes-utiles/SelectorYear';
import { useInterval } from 'react-use';

export const FichajesUsuario = () => {

	const [fichajes, setFichajes] = useState([]);
	const [loaded, setLoaded] = useState([]);

	const [nombreMes, setNombreMes] = useState('');
	const [mes, setMes] = useState(new Date().getMonth() + 1);
	const [nombre, setNombre] = useState(" ");
	const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
	const [years, setYears] = useState([]);
	const param = useParams();
	const [esadmin, setEsadmin] = useState(false);




	const fichajesUsuario = async (id) => {
		try {
			const response = await getFichajesUsuario(mes, yearSelected, id);
			console.log(response);
			
			setFichajes(response.data.fichajes);
			setNombre(response.data.nombre.nombre);
			setYears(response.data.years);
			setEsadmin(response.esadmin);
			setLoaded(true);
		} catch (error) {
			console.error("Error al añadir el cliente:", error);
		}
	}
	useInterval(fichajesUsuario, 60000, param.id);
	useEffect(() => {
		fichajesUsuario(param.id);
		setNombreMes(mesName(mes))
	}, []);

	useEffect(() => {
		fichajesUsuario(param.id);
		setNombreMes(mesName(mes))
	}, [mes, yearSelected]);


	return (
		<Grid container direction={'row'} alignItems={'start'} justifyContent={'center'} xs={12}>
			{/* <div className='menu-back fade-in-2'> */}
			<SubHeader></SubHeader>
			<Grid container xs={11} padding={"1em"} direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={2}>

				<Grid container xs={12} sm={5} md={4} direction={'row'} justifyContent={'start'} alignItems={'start'}>
					<Typography variant='h4'>
						Fichajes de {nombre ? nombre : ""}
					</Typography>
				</Grid>
				<Grid container xs={5} sm={3} md={2} direction={'row'} justifyContent={'center'} alignItems={'center'}>
					{mes && (
						<SelectorMes mes={mes} setMes={setMes} />
					)}
				</Grid>
				<Grid container xs={5} sm={3} md={2} direction={'row'} justifyContent={'center'} alignItems={'center'}>
					{years.length >= 1 && (
						<SelectorYear years={years} setYearSelected={setYearSelected} yearSelected={yearSelected} />
					)}
				</Grid>

				<Divider sx={{ minWidth: '100%' }} />

				{fichajes.length <= 0 && (
					<Grid container xs={12} justifyContent={'center'} alignItems={'center'}>
						<strong>Todavía no hay fichajes</strong>
					</Grid>
				)}
				{fichajes ? fichajes.map((fichaje, index) => (
					<FichajeCard fichaje={fichaje} nombreMes={nombreMes} key={index} esadmin={esadmin}></FichajeCard>
				)) : ''}
			</Grid >
			{/* </div> */}
		</Grid >
	)
}
